// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.viewport {
  height: 300px;
  overflow-y: auto;
}

.tabs {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.tab {
  position: relative;
  padding: 10px;
  cursor: pointer;
}

.tab:hover .underline:not(.active) {
  transform: scaleX(1);
}

.tab .underline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: #ccc;
  transform: scaleX(0);
  transition: transform 0.3s ease-in-out;
}

.tab .underline.active {
  background-color: #007bff;
  transform: scaleX(1);
}

ion-list {
  background-color: white;
}

.item-list-card {
  --border-style: none;
  --inner-border-width: 0px;
  margin: 10px 15px;
  box-shadow: rgba(99, 99, 99, 0.3) 0px 0px 4px 1px;
}

ion-avatar img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 2px solid #fff;
}

ion-label h2 {
  margin-top: 0;
  color: #333;
}

ion-label h3 {
  color: #007bff;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/sessions/list-session/list-session.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;AACJ;;AAIA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AADJ;;AAIE;EACE,kBAAA;EACA,aAAA;EACA,eAAA;AADJ;;AAIE;EACE,oBAAA;AADJ;;AAIE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,sCAAA;AADJ;;AAIE;EACE,yBAAA;EACA,oBAAA;AADJ;;AASE;EACE,uBAAA;AANJ;;AASE;EACE,oBAAA;EACA,yBAAA;EACA,iBAAA;EACA,iDAAA;AANJ;;AASE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AANJ;;AASE;EACE,aAAA;EACA,WAAA;AANJ;;AASE;EACE,cAAA;AANJ","sourcesContent":[".viewport {\r\n    height: 300px;\r\n    overflow-y: auto;\r\n}\r\n\r\n//TAB CSS\r\n\r\n.tabs {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    position: relative;\r\n  }\r\n  \r\n  .tab {\r\n    position: relative;\r\n    padding: 10px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .tab:hover .underline:not(.active) {\r\n    transform: scaleX(1);\r\n  }\r\n  \r\n  .tab .underline {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 3px;\r\n    background-color: #ccc;\r\n    transform: scaleX(0);\r\n    transition: transform 0.3s ease-in-out;\r\n  }\r\n  \r\n  .tab .underline.active {\r\n    background-color: #007bff;\r\n    transform: scaleX(1);\r\n  }\r\n\r\n  //TAB CSS\r\n\r\n  // Liste item CSS\r\n\r\n\r\n  ion-list {\r\n    background-color: white;\r\n  }\r\n  \r\n  .item-list-card {\r\n    --border-style: none;\r\n    --inner-border-width: 0px;\r\n    margin: 10px 15px;\r\n    box-shadow: rgba(99, 99, 99, 0.3) 0px 0px 4px 1px;\r\n  }\r\n  \r\n  ion-avatar img {\r\n    width: 60px;\r\n    height: 60px;\r\n    border-radius: 50%;\r\n    border: 2px solid #fff;\r\n  }\r\n  \r\n  ion-label h2 {\r\n    margin-top: 0;\r\n    color: #333;\r\n  }\r\n  \r\n  ion-label h3 {\r\n    color: #007bff;\r\n  }\r\n\r\n  \r\n  // FIN LISTE ITEM CSS"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
